import { render, staticRenderFns } from "./comportamento.vue?vue&type=template&id=13b7a050&"
import script from "./comportamento.vue?vue&type=script&lang=js&"
export * from "./comportamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports